/**
 * Generated by orval 🍺
 * Do not edit manually.
 * OpenGoal Platform API
 * Agency-facing API — day-to-day platform usage by agency users.
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgencyClubDto,
  AgencyClubsControllerListAgencyClubsV1200,
  AgencyClubsControllerListAgencyClubsV1Params,
  CreateAgencyClubDto,
  RemoveAgencyClubResponseDto,
  UpdateAgencyClubDto
} from '../model';

import { apiRequest } from '../../client.ts';




const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getAgencyClubsControllerListAgencyClubsV1Url = (params?: AgencyClubsControllerListAgencyClubsV1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/agency-clubs?${stringifiedParams}` : `/v1/agency-clubs`
}

/**
 * @summary List the caller's agency clubs (paginated, searchable, orderable, filterable by relationship)
 */
export const agencyClubsControllerListAgencyClubsV1 = async (params?: AgencyClubsControllerListAgencyClubsV1Params, options?: RequestInit): Promise<AgencyClubsControllerListAgencyClubsV1200> => {

  return apiRequest<AgencyClubsControllerListAgencyClubsV1200>(getAgencyClubsControllerListAgencyClubsV1Url(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAgencyClubsControllerListAgencyClubsV1QueryKey = (params?: AgencyClubsControllerListAgencyClubsV1Params,) => {
    return [
    `/v1/agency-clubs`, ...(params ? [params] : [])
    ] as const;
    }


export const getAgencyClubsControllerListAgencyClubsV1QueryOptions = <TData = Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError = unknown>(params?: AgencyClubsControllerListAgencyClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyClubsControllerListAgencyClubsV1QueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>> = ({ signal }) => agencyClubsControllerListAgencyClubsV1(params, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyClubsControllerListAgencyClubsV1QueryResult = NonNullable<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>>
export type AgencyClubsControllerListAgencyClubsV1QueryError = unknown


export function useAgencyClubsControllerListAgencyClubsV1<TData = Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError = unknown>(
 params: undefined |  AgencyClubsControllerListAgencyClubsV1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerListAgencyClubsV1<TData = Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError = unknown>(
 params?: AgencyClubsControllerListAgencyClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerListAgencyClubsV1<TData = Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError = unknown>(
 params?: AgencyClubsControllerListAgencyClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List the caller's agency clubs (paginated, searchable, orderable, filterable by relationship)
 */

export function useAgencyClubsControllerListAgencyClubsV1<TData = Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError = unknown>(
 params?: AgencyClubsControllerListAgencyClubsV1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerListAgencyClubsV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyClubsControllerListAgencyClubsV1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgencyClubsControllerAddClubV1Url = () => {




  return `/v1/agency-clubs`
}

/**
 * Assigns an existing club (search `GET /v1/clubs` for its id) to the agency, along with the agency-level relationship and contacts. Agencies never create catalog clubs.
 * @summary Add a club from the catalog to the caller's agency
 */
export const agencyClubsControllerAddClubV1 = async (createAgencyClubDto: CreateAgencyClubDto, options?: RequestInit): Promise<AgencyClubDto> => {

  return apiRequest<AgencyClubDto>(getAgencyClubsControllerAddClubV1Url(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(createAgencyClubDto)
  }
);}





export const getAgencyClubsControllerAddClubV1QueryKey = (createAgencyClubDto?: CreateAgencyClubDto,) => {
    return [
    'POST', `/v1/agency-clubs`, createAgencyClubDto
    ] as const;
    }


export const getAgencyClubsControllerAddClubV1QueryOptions = <TData = Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError = unknown>(createAgencyClubDto: CreateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyClubsControllerAddClubV1QueryKey(createAgencyClubDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>> = ({ signal }) => agencyClubsControllerAddClubV1(createAgencyClubDto, { signal });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyClubsControllerAddClubV1QueryResult = NonNullable<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>>
export type AgencyClubsControllerAddClubV1QueryError = unknown


export function useAgencyClubsControllerAddClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError = unknown>(
 createAgencyClubDto: CreateAgencyClubDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerAddClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError = unknown>(
 createAgencyClubDto: CreateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerAddClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError = unknown>(
 createAgencyClubDto: CreateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Add a club from the catalog to the caller's agency
 */

export function useAgencyClubsControllerAddClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError = unknown>(
 createAgencyClubDto: CreateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerAddClubV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyClubsControllerAddClubV1QueryOptions(createAgencyClubDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgencyClubsControllerFindOneV1Url = (id: string,) => {




  return `/v1/agency-clubs/${id}`
}

/**
 * @summary One agency club, with its full contact list
 */
export const agencyClubsControllerFindOneV1 = async (id: string, options?: RequestInit): Promise<AgencyClubDto> => {

  return apiRequest<AgencyClubDto>(getAgencyClubsControllerFindOneV1Url(id),
  {
    ...options,
    method: 'GET'


  }
);}





export const getAgencyClubsControllerFindOneV1QueryKey = (id: string,) => {
    return [
    `/v1/agency-clubs/${id}`
    ] as const;
    }


export const getAgencyClubsControllerFindOneV1QueryOptions = <TData = Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyClubsControllerFindOneV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>> = ({ signal }) => agencyClubsControllerFindOneV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyClubsControllerFindOneV1QueryResult = NonNullable<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>>
export type AgencyClubsControllerFindOneV1QueryError = unknown


export function useAgencyClubsControllerFindOneV1<TData = Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerFindOneV1<TData = Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerFindOneV1<TData = Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary One agency club, with its full contact list
 */

export function useAgencyClubsControllerFindOneV1<TData = Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerFindOneV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyClubsControllerFindOneV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgencyClubsControllerUpdateClubV1Url = (id: string,) => {




  return `/v1/agency-clubs/${id}`
}

/**
 * Sending `contacts` replaces the whole list; omitting it leaves contacts untouched. The club itself is global reference data and is not editable here.
 * @summary Update the agency-level data (relationship, contacts)
 */
export const agencyClubsControllerUpdateClubV1 = async (id: string,
    updateAgencyClubDto: UpdateAgencyClubDto, options?: RequestInit): Promise<AgencyClubDto> => {

  return apiRequest<AgencyClubDto>(getAgencyClubsControllerUpdateClubV1Url(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(updateAgencyClubDto)
  }
);}





export const getAgencyClubsControllerUpdateClubV1QueryKey = (id: string,
    updateAgencyClubDto?: UpdateAgencyClubDto,) => {
    return [
    'PATCH', `/v1/agency-clubs/${id}`, updateAgencyClubDto
    ] as const;
    }


export const getAgencyClubsControllerUpdateClubV1QueryOptions = <TData = Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError = unknown>(id: string,
    updateAgencyClubDto: UpdateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyClubsControllerUpdateClubV1QueryKey(id,updateAgencyClubDto);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>> = ({ signal }) => agencyClubsControllerUpdateClubV1(id,updateAgencyClubDto, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyClubsControllerUpdateClubV1QueryResult = NonNullable<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>>
export type AgencyClubsControllerUpdateClubV1QueryError = unknown


export function useAgencyClubsControllerUpdateClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError = unknown>(
 id: string,
    updateAgencyClubDto: UpdateAgencyClubDto, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerUpdateClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError = unknown>(
 id: string,
    updateAgencyClubDto: UpdateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerUpdateClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError = unknown>(
 id: string,
    updateAgencyClubDto: UpdateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Update the agency-level data (relationship, contacts)
 */

export function useAgencyClubsControllerUpdateClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError = unknown>(
 id: string,
    updateAgencyClubDto: UpdateAgencyClubDto, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerUpdateClubV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyClubsControllerUpdateClubV1QueryOptions(id,updateAgencyClubDto,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getAgencyClubsControllerRemoveClubV1Url = (id: string,) => {




  return `/v1/agency-clubs/${id}`
}

/**
 * Deletes the assignment and its contacts. The club stays in the global catalog.
 * @summary Remove a club from the caller's agency
 */
export const agencyClubsControllerRemoveClubV1 = async (id: string, options?: RequestInit): Promise<RemoveAgencyClubResponseDto> => {

  return apiRequest<RemoveAgencyClubResponseDto>(getAgencyClubsControllerRemoveClubV1Url(id),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getAgencyClubsControllerRemoveClubV1QueryKey = (id: string,) => {
    return [
    'DELETE', `/v1/agency-clubs/${id}`
    ] as const;
    }


export const getAgencyClubsControllerRemoveClubV1QueryOptions = <TData = Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAgencyClubsControllerRemoveClubV1QueryKey(id);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>> = ({ signal }) => agencyClubsControllerRemoveClubV1(id, { signal });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type AgencyClubsControllerRemoveClubV1QueryResult = NonNullable<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>>
export type AgencyClubsControllerRemoveClubV1QueryError = unknown


export function useAgencyClubsControllerRemoveClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerRemoveClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>,
          TError,
          Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useAgencyClubsControllerRemoveClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Remove a club from the caller's agency
 */

export function useAgencyClubsControllerRemoveClubV1<TData = Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof agencyClubsControllerRemoveClubV1>>, TError, TData>>, }
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getAgencyClubsControllerRemoveClubV1QueryOptions(id,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






